export let federalT3InitialData = [
	{
		id: "1",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "2",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "3",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "4",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "5",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
];

export const federalT3headerColumns = [
	{
		field: "fromA",
		headerName: "$A from",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `toA`,
		headerName: `$A to`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "rateR",
		headerName: "Rate R",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "constantK",
		headerName: "Constant K",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
];

export let provinsionalInitialData = [
	{
		id: "1",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "2",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "3",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "4",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
	{
		id: "5",
		fromA: null,
		toA: null,
		rateR: null,
		constantK: null,
	},
];

export const provinsionalheaderColumns = [
	{
		field: "fromA",
		headerName: "$A from",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `toA`,
		headerName: `$A to`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "rateR",
		headerName: "Rate V",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "constantK",
		headerName: "Constant KP",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
];
export let federalClaimCodesInitialData = [
	{
		id: "1",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "2",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "3",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "4",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "5",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
];

export const federalClaimCodesheaderColumns = [
	{
		field: "claimCode",
		headerName: "Claim Code",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `totalClaimAmountMin`,
		headerName: `Total Claim Amount 1`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "totalClaimAmountMax",
		headerName: "Total Claim Amount 2",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "tc",
		headerName: "TC = ($)",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "k1p",
		headerName: "K1 = ($)",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
];
export let provinsionalClaimCodesInitialData = [
	{
		id: "1",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "2",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "3",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "4",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
	{
		id: "5",
		claimCode: null,
		totalClaimAmountMin: null,
		totalClaimAmountMax: null,
		tc: null,
		k1p: null,
	},
];

export const provinsionalClaimCodesheaderColumns = [
	{
		field: "claimCode",
		headerName: "Claim Code",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `totalClaimAmountMin`,
		headerName: `Total Claim Amount 1`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "totalClaimAmountMax",
		headerName: "Total Claim Amount 2",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "tc",
		headerName: "TC = ($)",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "k1p",
		headerName: "K1 = ($)",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
];
export let quebecProvinsionalClaimCodesInitialData = [
	{
		id: "1",
		code: null,
		amountMin: null,
		amountMax: null,
	},
	{
		id: "2",
		code: null,
		amountMin: null,
		amountMax: null,
	},
	{
		id: "3",
		code: null,
		amountMin: null,
		amountMax: null,
	},
	{
		id: "4",
		code: null,
		amountMin: null,
		amountMax: null,
	},
	{
		id: "5",
		code: null,
		amountMin: null,
		amountMax: null,
	},
];

export const quebecProvinsionalClaimCodesheaderColumns = [
	{
		field: "code",
		headerName: "Code",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `amountMin`,
		headerName: `Amount ($) 1`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "amountMax",
		headerName: "Amount ($) 2",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
];

// Provisional Variables
export let provisionalVariableSInitialData = [
	{
		id: "1",
		greaterThanA: null,
		lessThanEqualA: null,
		lessorOf1: null,
		lessorOf2: null,
	},
	{
		id: "2",
		greaterThanA: null,
		lessThanEqualA: null,
		lessorOf1: null,
		lessorOf2: null,
	},
	{
		id: "3",
		greaterThanA: null,
		lessThanEqualA: null,
		lessorOf1: null,
		lessorOf2: null,
	},
];

export const provisionalVariableSheaderColumns = [
	{
		field: "greaterThanA",
		headerName: "A >",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `lessThanEqualA`,
		headerName: `A =<`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "lessorOf1",
		headerName: "Lessor of 1",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "lessorOf2",
		headerName: "Lessor of 2",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
];

export let provisionalVariableV1InitialData = [
	{
		id: "1",
		greaterThanT4: null,
		lessThanEqualT4: null,
		v1: null,
	},
	{
		id: "2",
		greaterThanT4: null,
		lessThanEqualT4: null,
		v1: null,
	},
	{
		id: "3",
		greaterThanT4: null,
		lessThanEqualT4: null,
		v1: null,
	},
];

export const provisionalVariableV1headerColumns = [
	{
		field: "greaterThanT4",
		headerName: "T4 >",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `lessThanEqualT4`,
		headerName: `T4 =<`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "v1",
		headerName: "V1",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
];

export let provisionalVariableV2InitialData = [
	{
		id: "1",
		greaterThanA: null,
		lessThanEqualA: null,
		v2Equal: null,
		lessorOf1: null,
		lessorOf2: null,
	},
	{
		id: "2",
		greaterThanA: null,
		lessThanEqualA: null,
		v2Equal: null,
		lessorOf1: null,
		lessorOf2: null,
	},
	{
		id: "3",
		greaterThanA: null,
		lessThanEqualA: null,
		v2Equal: null,
		lessorOf1: null,
		lessorOf2: null,
	},
];

export const provisionalVariableV2headerColumns = [
	{
		field: "greaterThanA",
		headerName: "A >",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `lessThanEqualA`,
		headerName: `A =<`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "v2Equal",
		headerName: "V2 =",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "lessorOf1",
		headerName: "Lessor of 1",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "lessorOf2",
		headerName: "Lessor of 2",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
        
	},
];
